import { createContext, useContext } from 'react';

export interface EventsDialogApi {
  baseUrl: string;
  spaceId: string;
}

const EventsDialogApiContext = createContext<EventsDialogApi | null>(null);

export const EventsDialogApiProvider = EventsDialogApiContext.Provider;

export const useEventsDialogApi = () => {
  return useContext(EventsDialogApiContext);
};

export default EventsDialogApiContext;
